export function getReferrerUrl() {
  return typeof window !== undefined
    ? encodeURIComponent(window.document.referrer)
    : ""
}
